import { StateGlobal } from '../../providers/globalContext/interface'

export const initialState = {
  state: {
    user: '',
  } as StateGlobal,
}
